<template>
  <div v-if="tapRequestId" id="servicesWrapper">
    <SectionTitle
      icon="fas fa-file-user"
      :content="config.title"
      container-class="mb-3"
      reverse
    />

    <div class="col-12">
      <DynamicFormList :items="localItems">
        <template #items="{ item }">
          <DynamicFormListItem class="bg-light-gray border-radius--light">
            <template #default="{ active, toggle }">
              <ServiceItem
                :schema="config.schema"
                :item="item"
                cols="col-md col-6"
              >
                <template
                  v-if="
                    canEditOrAdd && !active && (!hideActions || item.id < 0)
                  "
                  #actions
                >
                  <div class="col-md-2 col-lg-2 pr-0">
                    <div
                      class="mt-3 d-md-flex d-lg-flex justify-content-end align-items-center"
                    >
                      <MenuDropDown
                        title="Acciones"
                        :items="[
                          {
                            label: 'Editar',
                            icon: 'fas fa-edit fa-fw text-green',
                            border: 'bottom',
                            click: toggle,
                          },
                          {
                            label: 'Eliminar',
                            icon: 'fas fa-times-circle fa-fw text-red',
                            click: () => remove(item),
                          },
                        ]"
                      />
                    </div>
                  </div>
                </template>
              </ServiceItem>

              <template v-if="canEditOrAdd && active">
                <div
                  :style="{
                    'border-top': '1px solid #E2E2E2',
                    margin: '.5rem 0',
                  }"
                />
                <slot
                  name="edit-form"
                  :props="{
                    items: localItems,
                    item,
                    editting: active,
                    statusId,
                  }"
                  :listeners="{ submit: edit, cancel: toggle }"
                />
              </template>
            </template>
          </DynamicFormListItem>
        </template>

        <template v-if="canEditOrAdd" #form="{ toggle }">
          <slot
            name="form"
            :props="{ items: localItems, statusId }"
            :listeners="{ submit: add, cancel: toggle }"
          />
        </template>

        <template v-if="canEditOrAdd" #form-toggler="{ toggle }">
          <template v-if="hasItems">
            <div class="text-right">
              <ActionButton
                text="Añadir"
                variant="success m-1"
                i="fas fa-file-plus"
                :responsive="false"
                @click="toggle"
              />
            </div>
          </template>
          <template v-else>
            <ActivationButton
              :text="
                `Presione aquí para añadir ${$options.filters.toLowerCase(
                  config.title
                )}`
              "
              @click.stop="toggle"
            />
          </template>
        </template>
      </DynamicFormList>
    </div>

    <div
      v-if="!canEditOrAdd && !hasItems"
      class="bg-light-gray border-radius--light py-4 text-center"
      v-text="`No posee ${$options.filters.toLowerCase(config.title)}`"
    />
  </div>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import {
  ActivationButton,
  DynamicFormList,
  DynamicFormListItem,
} from '@/components/common/';
import ActionButton from 'ActionButton';
import MenuDropDown from 'dropdown';
import ServiceItem from './ServiceItem';
import { servicesProvidedApi } from '../_api';
import { tapRequestStatusesEnum } from '@/components/pei/ubication-tech-assistance/_types';

export default {
  name: 'ServiceFormWrapper',
  components: {
    SectionTitle,
    DynamicFormList,
    DynamicFormListItem,
    MenuDropDown,
    ActionButton,
    ServiceItem,
    ActivationButton,
  },
  props: {
    config: { type: Object, required: true, default: null },
    tapRequestId: { type: Number, required: true, default: null },
    submitted: { type: Boolean, default: false },
    canEdit: { type: Boolean, default: false },
    saveLocally: { type: Boolean, default: false },
    hideActions: { type: Boolean, default: false },
    items: { type: Array, required: true, default: () => [] },
    statusId: { type: Number, default: 0 },
  },
  data: () => ({ localItems: [] }),
  computed: {
    hasItems() {
      return !!this.items.length;
    },
    canEditOrAdd() {
      return this.canEdit;
    },
  },
  methods: {
    getRandomId() {
      const id = Math.floor(Math.random() * 1000000);
      return id;
    },
    getNegativeRandomId() {
      return this.getRandomId() * -1;
    },
    async add(item, reset) {
      if (
        this.submitted &&
        this.statusId !== tapRequestStatusesEnum['Proceso de Enmienda']
      ) {
        return;
      }

      const result = this.saveLocally
        ? { id: this.getNegativeRandomId() }
        : await servicesProvidedApi.create(this.tapRequestId, item);

      if (result) {
        this.localItems.push({ ...item, id: result.id });
        reset();
      }
    },
    async edit(item, reset) {
      const result = this.saveLocally
        ? { id: -1 }
        : await servicesProvidedApi.edit(this.tapRequestId, item.id, item);

      if (result) {
        const index = this.localItems.findIndex((x) => x.id === item.id);
        this.localItems.splice(index, 1, item);
        reset();
      }
    },
    async remove(item) {
      const result = this.saveLocally
        ? { id: -1 }
        : await servicesProvidedApi.remove(this.tapRequestId, item.id);

      if (result) {
        const index = this.localItems.findIndex((x) => x.id === item.id);
        this.localItems.splice(index, 1);
      }
    },
  },
  filters: {
    toLowerCase(value) {
      return value?.toLowerCase();
    },
  },
  watch: {
    items: {
      handler() {
        if (!this.localItems.length) {
          this.localItems = this.items;
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
#servicesWrapper .tag-badge-title-info {
  font: Bold 15px Lato;
  color: #11291b;
  margin-top: 0;
  display: flex;
  align-items: center;
}
</style>
